import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=58969592"
import script from "./AI.vue?vue&type=script&lang=js"
export * from "./AI.vue?vue&type=script&lang=js"
import style0 from "./AI.vue?vue&type=style&index=0&id=58969592&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports